import * as React from "react";

import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from "@egds/react-core/images";
import { UitkLayoutFlexItem } from "@egds/react-core/layout-flex";
import { UitkSpacing } from "@egds/react-core/spacing";

interface AirlineLogoProps {
  isMobile: boolean;
  logoUrl: string;
  logoAlt: string;
}

export const AirlineLogo: React.FC<AirlineLogoProps> = ({ isMobile, logoUrl, logoAlt }) => {
  const airlineLogoInlineSpace = isMobile ? "three" : "four";
  const airlineLogoWidth = 48;

  return (
    <UitkSpacing margin={{ inlineend: airlineLogoInlineSpace }}>
      <UitkLayoutFlexItem maxWidth={airlineLogoWidth} minWidth={airlineLogoWidth}>
        <div>
          <UitkFigure imageFit="contain" ratio={UitkFigureAspectRatioType.R1_1}>
            <UitkImage src={logoUrl} alt={logoAlt} lazyLoading="lazy" />
          </UitkFigure>
        </div>
      </UitkLayoutFlexItem>
    </UitkSpacing>
  );
};
